import {connect} from 'react-redux';

import {gettext} from 'topmeteo/utils/i18n';

import {showMatrix} from '../../actionCreators';

const ShowLabel = gettext('Show Product Matrix');
const HideLabel = gettext('Hide Product Matrix');

const MatrixToggle = ({shown, onClick}) => (
    <a className="struct-link matrix" onClick={onClick}>
        {shown ? HideLabel : ShowLabel}
    </a>
);

const mapDispatchToProps = (dispatch, {shown}) => ({
    onClick: () => dispatch(showMatrix(!shown)),
});

export default connect(null, mapDispatchToProps)(MatrixToggle);
